import { TEN_SECONDS_IN_MS } from './constants';

// Note: saving this file locally will blow away the events bound flag
// and repeatedly bind events in active browser windows due to a quirk in hot reloading

/**
 * A singleton for tracking whether a user interacted in the past n seconds.
 * Exported only for test purposes.
 */
export class UserActivitySingleton {
  private lastInteractionTimestamp: number = Date.now();

  private eventsBound = false;

  private handleEvent() {
    this.lastInteractionTimestamp = Date.now();
  }

  private bindEvents() {
    const callback = () => {
      this.handleEvent();
    };
    document.addEventListener('mousemove', callback);
    document.addEventListener('keydown', callback);
    document.addEventListener('scroll', callback, { capture: true });
  }

  /** Idempotent setup */
  public initialize() {
    if (this.eventsBound) {
      return;
    }

    this.eventsBound = true;
    this.bindEvents();
  }

  public anInteractionOccurredInThePastTenSeconds(): boolean {
    return Date.now() - this.lastInteractionTimestamp <= TEN_SECONDS_IN_MS;
  }

  /** Exported test method. Do not use */
  public __resetForTest() {
    this.lastInteractionTimestamp = 0;
  }
}

const userActivitySingleton = new UserActivitySingleton();

export default userActivitySingleton;
